import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { makeStyles } from "@mui/styles";
import log from "loglevel";
import React, { useEffect, useState } from "react";
import Draggable from "react-draggable";

import { useTheme } from "@mui/material";
import { SMALL_DEVICE_MEDIA_SIZE } from "components/common/constants";
import PropTypes from "prop-types";

const moduleStyles = makeStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    leftActions: {
        justifyContent: "flex-start",
        width: "50%",
        float: "left",
    },
    rightActions: {
        justifyContent: "flex-end",
        width: "50%",
        float: "right",
    },
    loadingSummary: {
        minHeight: 150,
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    pdfContainer: {
        maxHeight: 800,
        overflowY: "auto",
    },
}));

function getContent(url, _token, errorCallback) {
    const xhr = new XMLHttpRequest();

    xhr.open("GET", url);
    xhr.onreadystatechange = handler;
    xhr.responseType = "blob";
    if (_token) {
        xhr.setRequestHeader("Authorization", "Bearer " + _token);
    } else {
        xhr.withCredentials = true;
    }
    xhr.send();

    function handler() {
        if (this.readyState === this.DONE) {
            if (this.status === 200) {
                const data_url = URL.createObjectURL(this.response);
                document.getElementById("pdf-viewer-iframe").src = data_url;
                errorCallback(false);
            } else {
                errorCallback(true);
                log.error("Unable to load pdf for url: ", url);
            }
        }
    }
}
function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={"[class*=\"MuiDialogContent-root\"]"}>
            <Paper {...props} />
        </Draggable>
    );
}

const DialogTitle = (props) => {
    const classes = moduleStyles();
    const { children, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
};
function PdfViewer({ open, title =  "Report ", onClose, url, token, authenticated, onSend, canSend = false, clean }) {
    const [show, setShow] = useState(open);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(true);
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down(SMALL_DEVICE_MEDIA_SIZE));
    useEffect(() => {
        return function cleanup() {
            setShowError(false);
            setLoading(true);
            clean();
        };
    }, [clean]);
    useEffect(() => {
        log.debug(open, token);
        setShowError(false);
        if (open !== show) {
            setLoading(true);
            setShow(open);
            if ((open && token) || authenticated) {
                getContent(url, token, (error) => {
                    setShowError(error);
                    setLoading(false);
                });
            }
        }
    }, [authenticated, open, show, token, url]);

    const handleClose = () => {
        setShow(false);
        clean();
    };

    function handleOnSend() {
        if (onSend) {
            onSend();
            onClose();
        } else {
            clean();
        }
    }

    const dProps = isSmallDevice
        ? {
            fullScree: true,
        }
        : {
            maxWidth: "xl",
        };
    return (
        <Dialog
            open={show}
            {...dProps}
            aria-labelledby="draggable-dialog-title"
            PaperComponent={PaperComponent}
            onClose={handleClose}
        >
            <DialogTitle style={{ cursor: "move" }} id={"draggable-dialog-title"} onClose={handleClose}>
                <span>
                    {title}
                    {canSend && (
                        <Button
                            onClick={handleOnSend}
                            variant={"outlined"}
                            size={"small"}
                            color="secondary"
                            style={{ float: "right", marginRight: 50, marginTop: 5 }}
                        >
                            Send
                        </Button>
                    )}
                </span>
            </DialogTitle>
            <DialogContent style={{ minWidth: isSmallDevice ? "100vw" : 800 }}>
                {loading && <LinearProgress color="secondary" style={{ width: "100%" }} />}

                {showError && (
                    <MuiAlert elevation={6} variant="filled" severity="error">
                        Error loading the report. Please close and try again
                    </MuiAlert>
                )}
                <iframe
                    id="pdf-viewer-iframe"
                    allowFullScreen
                    title={"Advertising Report"}
                    style={{ width: "100%", height: 700, display: "block", border: 0 }}
                    name={"Pdf viewer"}
                />
            </DialogContent>
        </Dialog>
    );
}

PdfViewer.propTypes = {
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    url: PropTypes.string.isRequired,
    token: PropTypes.string,
    authenticated: PropTypes.bool,
    onSend: PropTypes.func,
    canSend: PropTypes.bool,
    clean: PropTypes.func.isRequired,
};

export default PdfViewer;
